import type { Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import apiUrls from "../../../api";
import type { IContentType } from "../../../model/unityObject";
import type { RootState } from "../store";

// `fetchCts` prettifies the raw backend `type` (e.g. "content_scene") by
// swapping "_" for "-" so it can be matched against our frontend model names
// (see fromModelNameGetDescription) - that means the stored `type` is no
// longer a valid `contentTypeType` literal, just a plain string. This shape,
// not `IContentType`, is what's actually held in the slice.
export interface IPrettifiedContentType extends Omit<IContentType, "type"> {
  type: string;
  infoTitle?: string;
  infoText?: string;
}

export interface ICTState {
  list: IPrettifiedContentType[];
}

const initialState: ICTState = {
  list: [],
};

export const contentTypesSlice = createSlice({
  name: "contentTypes",
  initialState,
  reducers: {
    setCts: (state: ICTState, action: PayloadAction<IPrettifiedContentType[]>) => {
      state.list = [...action.payload];
    },
  },
});

export const { setCts } = contentTypesSlice.actions;

export const fetchCts = () => (dispatch: Dispatch) => {
  axios
    .get<IContentType[]>(`${apiUrls.projects.contens.contentType}`)
    .then((res) => {
      const response = res.data.map((ct): IPrettifiedContentType => {
        // prettify "type" values (turning "_" into "-" ) so it can match our model names
        return {
          ...ct,
          type: String(ct.type).replace(/_/g, "-"),
          infoTitle: ct.title,
          infoText: ct.description,
        };
      });
      return dispatch(setCts(response));
    })
    .catch(console.error);
};

export const getCts = (state: RootState) => state.contentTypes.list;

export const contentTypesReducer = contentTypesSlice.reducer;
